// extracted by mini-css-extract-plugin
export default {"circle":"Circle_circle__yoE2s","first":"Circle_first__gUfO2","last":"Circle_last__3Jvsz"};